export {default as Auth_BG} from '../../assets/image/Auth_BG.png';
export { default as default_o } from '../../assets/image/default_o.png';
export { default as default_m } from '../../assets/image/default_m.png';
export { default as default_s } from '../../assets/image/default_s.png';

// Lottie files
// verify business email for testing purspose
const BUCKET_LOTTIE_FILES_URL = process.env.REACT_APP_BUCKET_URL + "dukaandost/lottie-files/"
export const correct = BUCKET_LOTTIE_FILES_URL + 'correct.json';
export const cancel = BUCKET_LOTTIE_FILES_URL + 'cancel.json';